<script>
import api from '@/helpers/api'
export default {
  name: 'new-address-dialog',
  props: {
    visible: { type: Boolean, default: false },
    addressId: { type: String },
    copyAddressId: { type: String },
    customerId: { type: String }
  },
  data: () => ({
    address: {},
    isLoading: false
  }),
  methods: {
    reset () {
      this.address = {}
    },
    onCancel () {
      this.$emit('update:visible', false)

      this.$nextTick(() => {
        this.reset()
      })
    },
    async init () {
      if (this.isUpdate) {
        let result = await api.addresses.fetch({
          id: this.addressId
        })
        this.address = { ...result }
      } else {
        if (this.copyAddressId) {
          let { alias, is_active, address } = await api.addresses.fetch({
            address_id: this.copyAddressId,
            customer_id: this.customerId
          })

          this.address = { ...address, alias, is_active }
        } else this.address = {}
      }
    },
    onSave () {
      let valid = true
      if (valid) {
        this.$emit('created', this.address)
        this.onCancel()
      }
    }
  },
  watch: {
    addressId: { handler: 'init', immediate: true },
    copyAddressId: { handler: 'init', immediate: true },
    visible: {
      handler (v) {
        if (v) this.init()
      }
    }
  },
  computed: {
    isUpdate () {
      return !!this.addressId
    },
    title () {
      return this.isUpdate ? 'Edit Address' : 'New Address'
    },
    saveBtnLabel () {
      return this.isUpdate ? 'Save Changes' : 'Create Address'
    }
  }
}
</script>
<template>
  <b-modal
    v-model="visible"
    :title="title"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    size="lg"
  >
    <b-form-group
      label="Alias"
      label-for="address_alias"
      label-cols-sm="3"
      v-if="false"
    >
      <b-form-input
        id="address_alias"
        v-model="address.alias"
        type="text"
        required
        autocomplete="address_alias"
        placeholder="Alias, or short name"
        :style="{ maxWidth: '350px' }"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-for="is_active"
      label-cols-sm="3"
      class="d-flex align-items-center"
      v-if="false"
    >
      <template v-slot:label>
        <div class="d-flex align-items-center pointer">Is Active</div>
      </template>
      <b-form-checkbox
        switch
        size="lg"
        id="is_active"
        v-model="address.is_active"
        name="is_active"
        inline
      ></b-form-checkbox>
    </b-form-group>

    <hr v-if="false" />
    <b-form-group
      label="Company Name"
      label-for="address_company_name"
      label-cols-sm="3"
    >
      <b-form-input
        id="address_company_name"
        v-model="address.company_name"
        type="text"
        required
        autocomplete="address_company_name"
        placeholder="Company Name"
        :style="{ maxWidth: '350px' }"
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Attn." label-for="attn" label-cols-sm="3">
      <b-form-input
        id="line1"
        v-model="address.attn"
        type="text"
        placeholder="Name of Person or Department"
        autocomplete="attn"
        :style="{ maxWidth: '350px' }"
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Street" label-for="line1" label-cols-sm="3">
      <b-form-input
        id="line1"
        v-model="address.street"
        type="text"
        required
        autocomplete="addressline1"
        placeholder="Street"
        :style="{ maxWidth: '450px' }"
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Number" label-for="number" label-cols-sm="3">
      <b-form-input
        id="number"
        v-model="address.number"
        type="text"
        required
        autocomplete="number"
        placeholder="number"
        :style="{ maxWidth: '100px' }"
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Addressline 2" label-for="line2" label-cols-sm="3">
      <b-form-input
        id="line2"
        v-model="address.line2"
        type="text"
        autocomplete="addressline2"
        placeholder="Additional info ex. bus, floor, department"
        :style="{ maxWidth: '450px' }"
      ></b-form-input>
    </b-form-group>

    <b-form-group label="Zipcode" label-for="zipcode" label-cols-sm="3">
      <b-form-input
        id="zipcode"
        v-model="address.zipcode"
        type="text"
        required
        autocomplete="zipcode"
        placeholder="Zipcode"
        :style="{ maxWidth: '150px' }"
      ></b-form-input>
    </b-form-group>

    <b-form-group label="City" label-for="city" label-cols-sm="3">
      <b-form-input
        id="city"
        v-model="address.city"
        type="text"
        required
        autocomplete="city"
        placeholder="City"
        :style="{ maxWidth: '280px' }"
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Country" label-for="country_code" label-cols-sm="3">
      <app-country-select
        id="country_code"
        v-model="address.country_code"
        :style="{ maxWidth: '100%' }"
      />
    </b-form-group>
    <b-form-group
      label="Rating"
      label-for="rating"
      label-cols-sm="3"
      description="Higest Ranked will be shown first"
    >
      <b-form-rating
        name="rating"
        v-model="address.rating"
        stars="10"
        size="md"
        style="max-width: 200px"
        class="border-0 m-0 p-0"
      ></b-form-rating>
    </b-form-group>
    <b-form-group
      label-for="is_default"
      label-cols-sm="4"
      class="d-flex align-items-center"
    >
      <template v-slot:label>
        <div class="d-flex align-items-center pointer">
          Use as standard shipping address
        </div>
      </template>
      <b-form-checkbox
        switch
        size="lg"
        id="is_default"
        v-model="address.is_default"
        name="is_default"
        inline
      ></b-form-checkbox>
    </b-form-group>

    <template v-slot:modal-footer>
      <div class="d-flex justify-content-end" style="width: 100%">
        <div>
          <b-button variant="link" @click="onCancel" class="mr-2"
            >Cancel</b-button
          >
          <b-btn variant="primary" class="btn-label" v-on:click="onSave">
            <i class="bx bxs-save label-icon"></i>
            {{ saveBtnLabel }}
          </b-btn>
        </div>
      </div>
    </template>
  </b-modal>
</template>
